import Immutable from 'immutable'

export const Quote = Immutable.Record({
  id: null,
  name: '',
  parts: Immutable.List([])
})

